module.exports = __webpack_public_path__ + "img/demand.32190c00.png";